// extracted by mini-css-extract-plugin
export default {"row":"notification-row_row__iEs4m","rowClickable":"notification-row_rowClickable__mTh+d"};